import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IDeleteHallPayload extends ISagaCb {
    hallId: string
}

export interface IDeleteHallState {
    status: string
    data: any
    errors: any
}

const initialState: IDeleteHallState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const deleteHall = createSlice({
    name: 'hall/delete',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeleteHallPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const deleteHallActions = deleteHall.actions
export default deleteHall.reducer
